import { Text } from '../../atoms/text';
import { PanelHeader } from '../panel/panel-header';
import type { InlineFormSectionHeaderProps } from '../../../types/inline-form-section.types';

/** Present the title and purpose consistently across inline settings forms. */
export function InlineFormSectionHeader({
  title,
  description,
  icon,
  headerAction,
}: InlineFormSectionHeaderProps) {
  return (
    <PanelHeader
      className="px-4 py-5 sm:px-6"
      childrenClassName="min-w-0 flex-1 basis-64"
      actionsClassName="ml-auto"
      actions={headerAction}
    >
      <div className="flex min-w-0 items-start gap-3">
        {icon && (
          <div className="shrink-0 rounded-lg bg-secondary-50 p-2" aria-hidden>
            {icon}
          </div>
        )}
        <div className="min-w-0 space-y-1">
          <Text as="h4" size="h6" weight="medium">
            {title}
          </Text>
          {description && (
            <Text size="small" color="secondary">
              {description}
            </Text>
          )}
        </div>
      </div>
    </PanelHeader>
  );
}
